import { message } from "antd";
import axios from "axios";
import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";
import { AxiosConfigAdmin, AxiosConfigAdminWithAdminToken } from "Admin/Config/AxiosConfig";

export const login = (data) => {
  if (
    data.email == "academic_online@gmail.com" &&
    data.password == "5678%^&*"
  ) {
    localStorage.setItem("academic_online_access_explore", true);
    return true;
  } else {
    localStorage.setItem("academic_online_access_explore", false);
    return false;
  }
};
export const logout = async () => {
  try {
    localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_admin_access_token`);
    localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_admin_refresh_token`);
    localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_access_token`);
    localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_refresh_token`)
    const currentUrl = `${window.location.origin}${window.location.pathname}`;
    window.location.href = `${process.env.REACT_APP_API_BASE_URL_ADMIN
      }/v2/auth/saml/logout?origin=${encodeURIComponent(currentUrl)}`;
  } catch (err) {
    console.error("Logout error:", err);
  } finally {
    message.error("Logout successfully");
  }
};
export const getAdminUserInfo = (callback) => {
  const axios = AxiosConfigAdminWithAdminToken();
  let url = `/user/about_me`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshAdminToken(() => getAdminUserInfo(callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const getUserInfo = (callback) => {
  const axios = AxiosConfigExplore();
  let url = `/user/about_me`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getUserInfo(callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const refreshToken = (callback) => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_refresh_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  let url = `/auth/refresh`;
  instance
    .get(url)
    .then((res) => {
      localStorage.setItem(
        `${process.env.REACT_APP_PREFIX}_access_token`,
        res.data.access_token
      );
      callback();
    })
    .catch((err) => {
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_admin_access_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_admin_refresh_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_access_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_refresh_token`)
    });
};

export const refreshAdminToken = (callback) => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_admin_refresh_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL_ADMIN}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  let url = `/auth/refresh`;
  instance
    .get(url)
    .then((res) => {
      localStorage.setItem(
        `${process.env.REACT_APP_PREFIX}_admin_access_token`,
        res.data.access_token
      );
      callback();
    })
    .catch((err) => {
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_admin_access_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_admin_refresh_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_access_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_refresh_token`)
    });
}